var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69593 22C10.3441 22 10.8391 21.7341 11.1809 21.2024L21.6346 4.59819C21.8939 4.1994 22 3.84894 22 3.51057C22 2.6284 21.3754 2 20.4915 2C19.8904 2 19.525 2.21752 19.1479 2.82175L9.64879 18.2538L4.78138 11.9215C4.42781 11.4502 4.05068 11.2568 3.52033 11.2568C2.63642 11.2568 2 11.8973 2 12.7795C2 13.1662 2.12964 13.5408 2.44785 13.9275L8.22275 21.2387C8.63524 21.7583 9.08309 22 9.69593 22Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-check.3071672eaad2f4606c5bde1b01fdcbc6.svg";